module.exports = __webpack_public_path__ + "static/media/Artboard9.2c3a77dd.png";